import { createLink, LinkProps } from '@tanstack/react-router'
import { TextCell } from 'components/table/cells/TextCell'
import React from 'react'
import styled from 'styled-components'

const StyledCell = styled.div<{ $hoverable?: boolean }>`
  display: flex;
  align-items: center;
  justify-items: center;
  flex-direction: row;
  text-decoration: none;
  height: 40px;
  gap: 0.75rem;
  padding-right: 0.25rem;
  border-radius: 4px;
  cursor: default;
  color: ${({ theme }) => theme.forecast.defaultText};
  ${({ $hoverable, theme }) =>
    $hoverable
      ? `
    cursor: pointer;
    &:hover {
      background-color: ${theme.forecast.defaultButton};
    }
  `
      : undefined}
`

const ThumbnailCellComponent = React.forwardRef<
  HTMLAnchorElement,
  LinkProps & {
    thumbnailString?: string
    thumbnailSubtitle?: string
    children: React.ReactNode
    hoverable?: boolean
    emptyText?: string
  }
>(
  (
    {
      thumbnailString,
      thumbnailSubtitle,
      children,
      hoverable,
      emptyText,
      ...linkProps
    },
    ref
  ) => {
    const cellContent = (
      <StyledCell $hoverable={hoverable}>
        {children}
        <TextCell
          truncate
          text={thumbnailString}
          subtitle={thumbnailSubtitle}
          emptyText={emptyText}
        />
      </StyledCell>
    )

    return (
      <a
        {...linkProps}
        ref={ref}
        onClick={(e) => e.stopPropagation()}
        style={{
          display: 'inline-block',
          textDecoration: 'none',
        }}>
        {cellContent}
      </a>
    )
  }
)

ThumbnailCellComponent.displayName = 'ThumbnailCellComponent'

export const ThumbnailCell = createLink(ThumbnailCellComponent)
